// extracted by mini-css-extract-plugin
module.exports = {"governance_create_form_container":"GovernanceCreateForm_governance_create_form_container__1wAln","parse_container":"GovernanceCreateForm_parse_container__3OEpn"};